import { FC } from "react";
import SourceDataItemValue, { ISourceDataItemValueProps } from "./SourceDataItemValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppSettings } from "@/AppSettings";
import { Box, Button, styled } from "@mui/material";

const DownloadButton = styled(Button)(({ theme }) => ({
    maxWidth: 0,
    minWidth: theme.spacing(5.25),
    minHeight: theme.spacing(5.25),
    margin: theme.spacing(-1),
    padding: 0,
    borderRadius: 0
}))

const SourceDataItemFileValue: FC<ISourceDataItemValueProps> = ({
    itemData,
    hideBorderStyles,
    hideStyles
}) => {

    return (
        <SourceDataItemValue
            hideBorderStyles={hideBorderStyles}
            hideStyles={hideStyles}
            endAdornment={
                !!itemData?.sourceDataItem?.value && (
                    <DownloadButton
                        //@ts-ignore
                        component="a"
                        href={`/open-clinica/source-document?FileName=${encodeURIComponent(itemData?.sourceDataItem?.value)}`}
                        target="_blank"
                    >
                        <FontAwesomeIcon 
                            size="lg"
                            icon={AppSettings.icons.download}

                        />
                    </DownloadButton>
                )
            }
        >
            {itemData?.value}
        </SourceDataItemValue>
    );
};

export default SourceDataItemFileValue;